import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "invisible",
  ref: "photo"
}
const _hoisted_2 = { class: "flex justify-center items-center md:justify-start" }
const _hoisted_3 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("figure", _hoisted_2, [
      _createElementVNode("img", {
        class: "border-complementary border-2 rounded-full w-48 lg:w-56 h-48 lg:h-56 object-cover",
        src: "/assets/me.webp",
        alt: _ctx.$t('about.photo')
      }, null, 8, _hoisted_3)
    ])
  ], 512))
}